import { render, staticRenderFns } from "./saveClassGroup.vue?vue&type=template&id=d3ef2d32"
import script from "./saveClassGroup.vue?vue&type=script&lang=js"
export * from "./saveClassGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports